import React from 'react';
import { Button, IconButton, Drawer } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import useOpenFilterModal from 'lib/hooks/useOpenFilterModal';

import SearchFilter from '../SearchFilter';
import { useStyles } from './styles';
import SaveClearSearchButtons from '../SearchFilter/SaveClearSearchButtons';

interface FiltersModalProps {
  onClick: () => void;
  isModalOpen: boolean;
  totalCount: number;
  searchVehicles: () => Promise<void>;
}

export default function FiltersModal({
  onClick,
  isModalOpen,
  totalCount,
  searchVehicles,
}: FiltersModalProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();

  const { setOpenModalOnSignIn, savedSearchId } = useOpenFilterModal();

  function onSearchVehicles(): void {
    searchVehicles();
    onClick();
  }

  return (
    <>
      <Drawer classes={{ paper: classes.paper }} open={isModalOpen} anchor={'right'}>
        <div className={classes.paper}>
          <div className={classes.modalHeader}>
            <div className={classes.headerTopRow}>
              <div className={classes.headerTitle}>{t('srp.filters.modalHeader')}</div>
              <IconButton
                className={classes.closeButton}
                onClick={onClick}
                aria-label={t('accessibility.closeModal')}
              />
            </div>
            <SaveClearSearchButtons
              mobileDrawer
              onClose={onClick}
              onSignedOutSaveSearch={(): void => setOpenModalOnSignIn(true)}
              savedSearchId={savedSearchId}
            />
          </div>
          <div className={classes.filtersListOuter}>
            <div className={classes.filtersList}>
              <SearchFilter hideOnMobile />
            </div>
          </div>

          <div className={classes.modalFooter}>
            <Button className={classes.resultsButton} onClick={onSearchVehicles}>
              {totalCount < 1000 ? totalCount : '1000+'} {t('srp.filters.results')}
            </Button>
          </div>
        </div>
      </Drawer>

      <style jsx>{`
        // disables scrolling of main page in mobile
        :global(html) {
          position: ${isModalOpen ? 'fixed' : undefined};
          width: ${isModalOpen ? '100%' : undefined};
        }
      `}</style>
    </>
  );
}
